import * as types from '../actionTypes/AnnualRewardsActionTypes';

export default function AnnualRewardsReducer(
    state = {
        showLoader: false,
        offers: [],
        offerSelection: null,
        selectedReward: null,
        error: null,
    },
    action = {}
) {
    switch (action.type) {
        case types.GET_VIP_OFFERS: {
            return { ...state, showLoader: true, error: null };
        }

        case types.GET_VIP_OFFERS_SUCCESS: {
            return {
                ...state,
                offers: action.offers,
                offerSelection: action.offerSelection,
                showLoader: false,
            };
        }

        case types.GET_VIP_OFFERS_ERROR: {
            return { ...state, error: action.error, showLoader: false };
        }

        case types.CONFIRM_REWARD_SELECTION: {
            return {
                ...state,
                showLoader: true,
                error: null,
                confirmVipRewardError: null,
                selectedReward: null,
            };
        }

        case types.CONFIRM_REWARD_SELECTION_SUCCESS: {
            return { ...state, selectedReward: action.selectedReward, showLoader: false };
        }

        case types.CONFIRM_REWARD_SELECTION_ERROR: {
            return {
                ...state,
                confirmVipRewardError: action.confirmVipRewardError,
                showLoader: false,
            };
        }

        default:
            return state;
    }
}

AnnualRewardsReducer.reducerName = 'annualRewardsDetails';
